var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',_vm._g({attrs:{"title":_vm.$t('title'),"white":""}},_vm.$listeners),[_c('SettingsView',{staticClass:"no-padding"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }